import React from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ArrowRightIcon } from "../../../assets/icons/arrowRight.svg";
import styles from "./HeaderTitle.module.css";

interface HeaderTitleProps {
  title?: string;
  showBackButton?: boolean;
  onBackNavigateTo?: string;
  children?: React.ReactNode;
}

const HeaderTitle: React.FC<HeaderTitleProps> = ({
  title,
  showBackButton = true,
  onBackNavigateTo = "/profile",
  children,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBackNavigateTo) {
      navigate(onBackNavigateTo);
    }
  };

  const isIOS = typeof window !== "undefined" && /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isBookingHistory = typeof window !== "undefined" && document.body.classList.contains("booking-history-safe-area-extend");

  return (
    <div className={`${styles.header} ${isIOS && isBookingHistory ? styles.bookingHistoryHeader : ""}`}>
      {title && <h1 className={styles.title}>{title}</h1>}
      {children && <div className={styles.customContent}>{children}</div>}
      {showBackButton && (
        <button className={styles.backButton} onClick={handleBack}>
          <ArrowRightIcon className={styles.icon} />
        </button>
      )}
    </div>
  );
};

export default HeaderTitle;
